<template>
  <div class="card cards__card cardTile">
    <div>
      <div class="card__image">
        <responsive-image :picture="image" />
      </div>
      <div
        class="card__title h4"
        v-text="title"
      />
      <div
        v-if="description"
        class="card__description"
        v-text="description"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageCard',
  props: {
    image: {
      type: Object,
      default() {
        return {}
      }
    },
    title: {
      type: String,
      default() {
        return ''
      }
    },
    description: {
      type: String || null,
      default() {
        return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  background-color: $color__white;
  padding: 1.8125rem;
  box-shadow: 0 .1875rem .375rem $color--card__shadow;
  margin: 1.25rem $default-margin-padding-width-small 0;

  @include breakpoint-down($md) {
    margin: 1.25rem 0 0;
  }

  &:hover {
    &__image {
      opacity: .8;
    }
  }

  &__image {
    min-height: 5rem;

    picture {
      display: flex;
      flex-flow: column;
      align-items: center;
    }
  }

  &__title {
    margin-top: $default-margin-padding-width;
    margin-left: 0;
    max-width: 100%;
    text-align: center;
  }

  &__description {
    padding-top: 2.125rem;
    overflow: hidden;
    color: $color__text__default;
    font-weight: lighter;
    line-height: 1.25em;
    text-align: center;
    font-size: map-get($base-text-body-medium,font-size );
  }
}
</style>
